import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pi0037',
    ecrans: ['00-2']
});
